export default function AreaPrimitive(overlay, ctx, layout, candles) {
    
    if (candles.length < 2) return
    
    ctx.strokeStyle = overlay.lineColor
    ctx.fillStyle = overlay.fillColor
    ctx.lineWidth = overlay.lineWidth
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    
    ctx.beginPath()
    
    // Start from the first candle
    let firstCandle = candles[0]
    let startX = layout.t2screen(firstCandle.raw[0])
    let startY = layout.$2screen(firstCandle.raw[4])
    ctx.moveTo(startX, startY)
    
    // Draw line through all candle close prices
    for (let i = 1; i < candles.length; i++) {
        let candle = candles[i]
        ctx.lineTo(layout.t2screen(candle.raw[0]), layout.$2screen(candle.raw[4]))
    }
    
    // Complete the area by drawing down to the bottom and back to start
    let lastCandle = candles[candles.length - 1]
    let endX = layout.t2screen(lastCandle.raw[0])
    let bottomY = layout.height // Use full height of chart area
    
    ctx.lineTo(endX, bottomY)
    ctx.lineTo(startX, bottomY)
    ctx.closePath()
    
    // Fill the area first, then stroke the line
    ctx.fill()
    
    // Redraw just the line on top
    ctx.beginPath()
    ctx.moveTo(startX, startY)
    for (let i = 1; i < candles.length; i++) {
        let candle = candles[i]
        ctx.lineTo(layout.t2screen(candle.raw[0]), layout.$2screen(candle.raw[4]))
    }
    ctx.stroke()
}
